import { NgModule } from "@angular/core";
import { DragScrollItemDirective } from "common/drag-scroll/drag-scroll-item";
import { DragScrollComponent } from "common/drag-scroll/drag-scroll.component";

@NgModule({
	exports: [DragScrollComponent, DragScrollItemDirective],
	declarations: [DragScrollComponent, DragScrollItemDirective],
})
export class DragScrollModule {}
